import { useQuery } from "@tanstack/react-query";
import { CPGetLinkedContactPeopleQueryResult } from "../../api/models/unified";
import customerUserClient from "../../api/private/customerUserClient";

export const linkedContactPeopleQueryKey = "linkedContactPeople";

export const getLinkedContactPeopleQueryKey = () => [
  linkedContactPeopleQueryKey,
];

export const useGetLinkedContactPeopleQuery = () => {
  return useQuery<CPGetLinkedContactPeopleQueryResult>({
    queryKey: getLinkedContactPeopleQueryKey(),
    queryFn: customerUserClient.getLinkedContactPeople,
  });
};
